import React from 'react';
import { EditOutlined, SearchOutlined , DeleteOutlined , DownOutlined, UpOutlined, PrinterOutlined} from "@ant-design/icons";

import {
  Row,
  Col,
  Button,
  Form,
  Input,
  Space,
  Table,
  Popover
} from "antd";

import { useState } from 'react';
import { useEffect } from 'react';
import enrollmentService from "../../api/enrollment.service";
import { Link, useNavigate } from 'react-router-dom';
import { SUCCESS_STATUS } from "../../utility/Constants";
import ProgrammeService from "../../api/programme.service";
import CustomTableSearch from "../common/CustomTableSearch";
import commonUtility from "../../utility/Utils";
import { PRINT_BASE_URL } from '../../utility/URL';


const TapMembershipListView = ({tapMembershipList}) => {
   const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
    const [page, setPage] = React.useState(1);
    let navigate = useNavigate();
    
/*
  const [paymentMonths,setPaymentMonths] = useState([]);


  const showMonths = (receipt_master_id) => {
    const data = {
      formdata: { receipt_master_id: receipt_master_id },
    };
    ProgrammeService.paymentMonthByReceipt(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
          setPaymentMonths(monthView(res.data.response_data));
          
      }
    });

  }

  const monthView = (months) => {

    return months.map((data) => {
      return (
        <div><p>{data.short_name} - {data.year}</p></div>
      )
    })

}


  const columns = [
    {
        title: 'Name',
        dataIndex: 'member_fname',
        key: 'member_fname',
        render: (selectedObj,render) => (
               <>
                {render.masterData.member_fname} {render.masterData.member_lname}
               </>
                
            
        )
  
      },
      {
        title: 'Mobile No',
        dataIndex: 'primary_mobile',
        key: 'primary_mobile',
        render: (selectedObj,render) => (
          <>
           {render.masterData.primary_mobile} 
          </>
           
       
   )
  
      },
   
    {
        title: 'Father Name',
        dataIndex: 'father_name',
        key: 'father_name',
        render: (selectedObj,render) => (
          <>
           {render.masterData.father_name} 
          </>
           
       
   )
  
      },

    {
        title: 'Validity',
        dataIndex: 'enrollment_start_date',
        key: 'enrollment_start_date',
        render: (selectedObj,render) => (
           <div style={{fontWeight:'bold',fontStyle:'italic'}}>{commonUtility.formatStringDate(render.masterData.enrollment_start_date)} to {commonUtility.formatStringDate(render.masterData.enrollment_end_date)}</div>
        )
      },
    
      {
        title: 'Paid Desc',
        dataIndex: 'address_one',
        key: 'address_one',
        render: (selectedObj,render) => (
          <>
            {
              render.detailsData.receipt_dtl_id > 0 ? <>
              <p style={{margin:0}}>Receipt No : {render.detailsData.receipt_no} </p>
              <p style={{margin:0}}>Receipt Date : {commonUtility.formatStringDate(render.detailsData.receipt_date)} </p>
              <h4>No of Months : &nbsp;
       
                <Popover content={paymentMonths} title="Months" trigger="click" onClick={()=>showMonths(render.detailsData.receipt_master_id)}>
                  <Button type="dashed" danger shape="circle" >{render.detailsData.no_of_months}</Button>
                </Popover>
                </h4>
              </> : ''
              
            }
          </>
       )
      },
    
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj,render) => (
        <Space size="middle">
              {
                render.detailsData.receipt_dtl_id > 0 ? <>
                  <>
                    <Button type="primary" shape='round' size='small' className='custom-button-green' >Paid </Button>
                    
                    <Link to={ render.detailsData.entry_from == "A" ?  `/enrollment-jcp/${render.detailsData.enrollment_id}/${render.detailsData.receipt_id}/${render.detailsData.payment_id}` : `/jcp-monthly/${render.detailsData.enrollment_id}/${render.detailsData.receipt_id}/${render.detailsData.payment_id}`} >
                      <Button htmlType="button" type="ghost" size="small" shape="round"  >Edit <EditOutlined /></Button>
                    </Link>
                  
                    
                    
    
                  </>
                </> : <>
                  <Link to={`/jcp-monthly/${render.masterData.member_id}`} >
                    <Button type="danger" shape='round' size='small'  >Pay Now</Button>
                  </Link>
                  
                </>
              }
             
        </Space>
      ),
    },

  ];


*/
  
function changeLocation(placeToGo) {
    navigate(placeToGo, { replace: true });
    window.location.reload();
}

//   useEffect(()=>{
//     console.log("Tap Member View List",tapMembershipList);
//   },[tapMembershipList])



  const tempcolumns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },
    {
      title: 'Receipt',
      dataIndex: 'receipt_no',
      key: 'receipt_no',
    },
    {
      title: 'Name',
      dataIndex: 'member_fname',
      key: 'member_fname',
      sorter: (a, b) => {
        const nameA = `${a.member_fname} ${a.member_lname}`;
        const nameB = `${b.member_fname} ${b.member_lname}`;
        return nameA.localeCompare(nameB);
      },
      render: (selectedObj,record) => (
        <Space>
            <span>{record.member_fname} {record.member_lname}</span>
        </Space>
      ),

    },
    {
      title: 'Mobile',
      dataIndex: 'primary_mobile',
      key: 'primary_mobile',
    },
    {
      title: 'Father Name',
      dataIndex: 'father_name',
      key: 'father_name',
    },
   
      {
        title: 'Validity',
        dataIndex: 'enrollment_start_date',
        key: 'enrollment_start_date',
        sorter: (a, b) => {
          const nameA = `${a.enrollment_date} ${a.enrollment_end_date}`;
          const nameB = `${b.enrollment_date} ${b.enrollment_end_date}`;
          return nameA.localeCompare(nameB);
        },
        render: (selectedObj,record) => (
          <Space>
              <span style={{fontWeight:700}}>{record.enrollment_date} to {record.enrollment_end_date}</span>
          </Space>
        ),
  
      },
      {
        title: 'Trainee',
        dataIndex: 'member_trainee',
        key: 'member_trainee',
      },
      {
        title: 'For Month',
        dataIndex: 'for_month',
        key: 'for_month',
        align:'right'
      },
      {
        title: 'Rate',
        dataIndex: 'rate_per_month',
        key: 'rate_per_month',
        align:'right'
      },
      {
        title: 'Action',
        key: 'action',
        width:90,
        render: (selectedObj) => (
  
          <Space style={{display:'flex',flexDirection:'row'}}>
            {/* <a onClick={()=> showDrawer(selectedObj)}>Edit {selectedObj.component_id}</a> */}
  
            {
              //console.log("slectedObj", selectedObj)
            }
  
            {/* <Link to="" onClick={() => changeLocation(`/tap/membership/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`)}>
              <Button htmlType="button" type="ghost" size="small" shape="round"  >Edit <EditOutlined /></Button>
            </Link> */}

            <Link to={`/tap/membership/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} >
              <Button htmlType="button" type="ghost" size="small" shape="round" className="custombutton-type1" >Edit <EditOutlined /></Button>
            </Link>

            <a href={`${PRINT_BASE_URL}tap/tapreceipt/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`} target="_blank" rel="noopener noreferrer">
           
            <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /> Print</Button>
            </a>

          </Space>
        ),
      },
  ];


  const columns = [
    {
      title: 'Name',
      dataIndex: 'member_fname',
      key: 'member_fname',
    },
    {
      title: 'Mobile',
      dataIndex: 'primary_mobile',
      key: 'primary_mobile',
    },
    {
      title: 'Father Name',
      dataIndex: 'father_name',
      key: 'father_name',
    },
    Table.EXPAND_COLUMN,
    { 
        title: "",
        dataIndex: "",
        key: "expand",
        width: 1 
    }
  ];


  const columns2 = [
    {
      title: 'Start Date',
      dataIndex: 'enrollment_date',
      key: 'enrollment_date',
    },
    {
      title: 'End Date',
      dataIndex: 'enrollment_end_date',
      key: 'enrollment_end_date',
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'y',
      render: () => <a>Edit</a>,
    },

  ];



  const expandedRowRenderFun = (i,record) => {
    return <Table  rowKey={list => list.key} columns={columns2}  className="nestedTable" dataSource={record} pagination={false} />;
  };






  return (
    <>

      {/* <CustomTableSearch onSearchTable={onSearch} /> */}
      {/* <Table columns={columns} rowKey='member_id' dataSource={jcpMonthlyUnPaidList} /> */}


      {/* <Table
    columns={columns}
    // expandable={{
    //   expandedRowRender: (record) => (
        
    //         {
    //             record.children.
    //         }
       

     

    //   ),
    // //  rowExpandable: (record) => record.name !== 'Not Expandable',
    // }}

    expandable={{
        expandedRowRender : (record) => expandedRowRenderFun(record),

    
      
      }}

    dataSource={tapMembershipList}
  /> */}



{/* <Table
    rowKey={list => list.key}
    columns={columns}
    className="parentTable"
    dataSource={tapMembershipList}
    expandIcon={({ expanded, onExpand, record }) =>
      expanded ? (
        <UpOutlined
          style={{ float: "right" }}
          onClick={e => onExpand(record, e)}
        />
      ) : (
        <DownOutlined onClick={e => onExpand(record, e)} />
      )
    }
    expandable={{
      expandedRowRender:(record,i) => expandedRowRenderFun(i,record.children)
    }}
  /> */}
        
        <Table 
        rowKey="enrollment_id" 
        columns={tempcolumns}  
        className="nestedTable" 
        dataSource={tapMembershipList}  
        size="small"
        pagination={{
          showTotal,
          onChange(current) {
            setPage(current);
          }
        }}
         />
    </>



  );
};

export default TapMembershipListView;